export class Payment {

  id: number;
  description: string;
  selected: boolean;

	constructor( p ?: any) {
    this.id = p ? p.id : null;
    this.description = p ? p.description : null;
    this.selected = false;
  }
  
  mapPayment(list: any[]): Payment[] {
    let newList: Payment[] = [];
    list.forEach((item: any) => {
      let newItem: Payment = new Payment(item);
      newList.push(newItem);
    });
    return newList;
  }

}
